import { render, staticRenderFns } from "./subscribe_short_form.vue?vue&type=template&id=2fd27715&scoped=true&"
import script from "./subscribe_short_form.vue?vue&type=script&lang=js&"
export * from "./subscribe_short_form.vue?vue&type=script&lang=js&"
import style0 from "./subscribe_short_form.vue?vue&type=style&index=0&id=2fd27715&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd27715",
  null
  
)

export default component.exports